import request from '@/utils/request'

export function getMenuTree() {
  return request({
    url: '/api/wms/menu/tree',
    method: 'get'
  })
}